module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"file-option-info":"Dateiinformationen","file-option-delete":"Löschen","file-option-download":"Herunterladen"},"fr":{"file-option-info":"Informations sur les fichiers","file-option-delete":"Effacer","file-option-download":"Télécharger"},"it":{"file-option-info":"Informazioni sul file","file-option-delete":"Cancellare","file-option-download":"Scaricare"}}')
  delete Component.options._Ctor
}
